"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = exports.persistor = exports.PersistGate = exports.useGetTestDataQuery = exports.notificationSlice = exports.featureFlagSlice = exports.faqCategorySlice = exports.playbookSlice = exports.promoSlice = exports.internalAdminsSlice = exports.myInviteSlice = exports.commentSlice = exports.topicSlice = exports.memberSlice = exports.devSlice = exports.settingSlice = exports.announcementSlice = exports.taskSlice = exports.faqSlice = exports.teamSlice = exports.workspaceSlice = exports.repositorySlice = exports.meSlice = exports.useAppSelector = exports.useAppDispatch = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var rootReducer_1 = __importDefault(require("./rootReducer"));
// import { setupListeners } from '@reduxjs/toolkit/query';
var meSlice_1 = require("./reducers/meSlice");
var repositorySlice_1 = require("./reducers/repositorySlice");
var workspaceSlice_1 = require("./reducers/workspaceSlice");
var teamSlice_1 = require("./reducers/teamSlice");
var devSlice_1 = require("./reducers/devSlice");
var analytics_1 = require("./services/analytics");
var faqSlice_1 = require("./reducers/faqSlice");
var taskSlice_1 = require("./reducers/taskSlice");
var memberSlice_1 = require("./reducers/memberSlice");
var settingSlice_1 = require("./reducers/settingSlice");
var announcementSlice_1 = require("./reducers/announcementSlice");
var myInviteSlice_1 = require("./reducers/myInviteSlice");
var internalAdminsSlice_1 = require("./reducers/internalAdminsSlice");
var react_redux_1 = require("react-redux");
var redux_persist_1 = require("redux-persist");
var playbookSlice_1 = require("./reducers/playbookSlice");
var topicSlice_1 = require("./reducers/topicSlice");
var commentSlice_1 = require("./reducers/commentSlice");
var persistConfig_1 = require("./middleware/persistConfig");
var promoSlice_1 = require("./reducers/promoSlice");
var faqCategorySlice_1 = require("./reducers/faqCategorySlice");
var notificationSlice_1 = require("./reducers/notificationSlice");
var persistedReducer = (0, redux_persist_1.persistReducer)(persistConfig_1.persistConfig, rootReducer_1.default);
var store = (0, toolkit_1.configureStore)({
    reducer: function (state, action) {
        // Hijack the logout/clearData action type
        if (action.type === 'logout/clearData') {
            state = undefined;
        }
        return persistedReducer(state, action);
    },
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    redux_persist_1.FLUSH,
                    redux_persist_1.REHYDRATE,
                    redux_persist_1.PAUSE,
                    redux_persist_1.PERSIST,
                    redux_persist_1.PURGE,
                    redux_persist_1.REGISTER,
                    'me/setDetails/pending',
                    'me/setDetails/fulfilled',
                    'me/setAccount',
                ],
            },
        }).concat(analytics_1.analyticsApi.middleware);
    },
});
exports.store = store;
var StoreConfig = function (firebaseApp, storageBucketConfig) {
    if (firebaseApp) {
        (0, meSlice_1.meSliceConfig)(firebaseApp);
        (0, faqCategorySlice_1.faqCategorySliceConfig)(firebaseApp);
        (0, repositorySlice_1.repositorySliceConfig)(firebaseApp);
        (0, repositorySlice_1.repositoryStorageConfig)(storageBucketConfig); // repository storage bucket
        (0, faqSlice_1.faqSliceConfig)(firebaseApp);
        (0, faqSlice_1.faqStorageConfig)(storageBucketConfig); // FAQ storage bucket
        (0, workspaceSlice_1.workspaceSliceConfig)(firebaseApp);
        (0, teamSlice_1.teamSliceConfig)(firebaseApp);
        (0, promoSlice_1.promoSliceConfig)(firebaseApp);
        (0, taskSlice_1.taskSliceConfig)(firebaseApp);
        (0, devSlice_1.devSliceConfig)(firebaseApp);
        (0, settingSlice_1.settingSliceConfig)(firebaseApp);
        (0, memberSlice_1.memberSliceConfig)(firebaseApp);
        (0, announcementSlice_1.announcementSliceConfig)(firebaseApp);
        (0, announcementSlice_1.announcementStorageConfig)(storageBucketConfig);
        (0, topicSlice_1.topicSliceConfig)(firebaseApp);
        (0, commentSlice_1.commentSliceConfig)(firebaseApp);
        (0, myInviteSlice_1.myInviteSliceConfig)(firebaseApp);
        (0, internalAdminsSlice_1.internalAdminsSliceConfig)(firebaseApp);
        (0, playbookSlice_1.playbookSliceConfig)(firebaseApp);
        (0, playbookSlice_1.playbookStorageConfig)(storageBucketConfig);
        (0, notificationSlice_1.notificationSliceConfig)(firebaseApp);
    }
};
// Use throughout your app instead of plain `useDispatch` and `useSelector`
var useAppDispatch = function () { return (0, react_redux_1.useDispatch)(); };
exports.useAppDispatch = useAppDispatch;
exports.useAppSelector = react_redux_1.useSelector;
exports.default = StoreConfig;
// export { IRepositoryState } from './interfaces/iRepositoryState';
/**
 * Slices export
 */
var slices_1 = require("./slices");
Object.defineProperty(exports, "meSlice", { enumerable: true, get: function () { return slices_1.meSlice; } });
Object.defineProperty(exports, "repositorySlice", { enumerable: true, get: function () { return slices_1.repositorySlice; } });
Object.defineProperty(exports, "workspaceSlice", { enumerable: true, get: function () { return slices_1.workspaceSlice; } });
Object.defineProperty(exports, "teamSlice", { enumerable: true, get: function () { return slices_1.teamSlice; } });
Object.defineProperty(exports, "faqSlice", { enumerable: true, get: function () { return slices_1.faqSlice; } });
Object.defineProperty(exports, "taskSlice", { enumerable: true, get: function () { return slices_1.taskSlice; } });
Object.defineProperty(exports, "announcementSlice", { enumerable: true, get: function () { return slices_1.announcementSlice; } });
Object.defineProperty(exports, "settingSlice", { enumerable: true, get: function () { return slices_1.settingSlice; } });
Object.defineProperty(exports, "devSlice", { enumerable: true, get: function () { return slices_1.devSlice; } });
Object.defineProperty(exports, "memberSlice", { enumerable: true, get: function () { return slices_1.memberSlice; } });
Object.defineProperty(exports, "topicSlice", { enumerable: true, get: function () { return slices_1.topicSlice; } });
Object.defineProperty(exports, "commentSlice", { enumerable: true, get: function () { return slices_1.commentSlice; } });
Object.defineProperty(exports, "myInviteSlice", { enumerable: true, get: function () { return slices_1.myInviteSlice; } });
Object.defineProperty(exports, "internalAdminsSlice", { enumerable: true, get: function () { return slices_1.internalAdminsSlice; } });
Object.defineProperty(exports, "promoSlice", { enumerable: true, get: function () { return slices_1.promoSlice; } });
Object.defineProperty(exports, "playbookSlice", { enumerable: true, get: function () { return slices_1.playbookSlice; } });
Object.defineProperty(exports, "faqCategorySlice", { enumerable: true, get: function () { return slices_1.faqCategorySlice; } });
Object.defineProperty(exports, "featureFlagSlice", { enumerable: true, get: function () { return slices_1.featureFlagSlice; } });
Object.defineProperty(exports, "notificationSlice", { enumerable: true, get: function () { return slices_1.notificationSlice; } });
var analytics_2 = require("./services/analytics");
Object.defineProperty(exports, "useGetTestDataQuery", { enumerable: true, get: function () { return analytics_2.useGetTestDataQuery; } });
var react_1 = require("redux-persist/integration/react");
Object.defineProperty(exports, "PersistGate", { enumerable: true, get: function () { return react_1.PersistGate; } });
exports.persistor = (0, redux_persist_1.persistStore)(store);
